var caseStatusTags = {
    opened: 'Reclamo Abierto',
    review: 'En Revisión',
    required: 'Acción Requerida',
    completed: 'Disputa Completada',
    cancelationPending: 'Cancelación Pendiente',
    canceled: 'Disputa Cancelada',
    lowBalance: 'Saldo bajo'
};
export default caseStatusTags;
//# sourceMappingURL=caseStatusTags.js.map